import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import { Badge } from "primereact/badge";
import { Ripple } from "primereact/ripple";

const PageSidebar = ({
    filteredPages, selectedSlug, pagesSearch, onSearchChange,
    onSelectPage, onNewPage, onBack,
}) => (
    <aside className="admin-pages-list">
        <div className="admin-pages-list-header">
            <h2 className="admin-text-lg">
                <i className="pi pi-th-large" />
                Páginas
                <Badge value={filteredPages.length} className="admin-pages-count-badge" />
            </h2>
        </div>
        <span className="p-input-icon-left admin-pages-search">
            <i className="pi pi-search" />
            <InputText
                className="admin-pages-field admin-pages-search-input admin-text-sm"
                value={pagesSearch}
                onChange={(event) => onSearchChange(event.target.value)}
                placeholder="Buscar..."
            />
        </span>
        <Button label="Volver" onClick={onBack} size="small" rounded icon="pi pi-arrow-left" />
        <Button rounded icon="pi pi-plus" label="Nueva página" size="small" onClick={onNewPage} severity="secondary" />
        <Button rounded icon="pi pi-refresh" label="Refrescar" size="small" onClick={() => window.location.reload()} severity="info" />

        {filteredPages.length === 0 ? (
            <div className="admin-pages-empty">
                <i className="pi pi-inbox" />
                <span>Sin resultados</span>
            </div>
        ) : (
            <div className="admin-pages-items-scroll" style={{ maxHeight: "calc(100vh - 320px)", overflow: "auto" }}>
                <div className="admin-pages-items-container">
                    {filteredPages.map((page) => (
                        <div
                            key={page.slug}
                            className={`admin-page-item ${selectedSlug === page.slug ? "active" : ""}`}
                            onClick={() => onSelectPage(page.slug)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => { if (e.key === "Enter") onSelectPage(page.slug); }}
                        >
                            <div className="admin-page-item-content">
                                <div className="admin-page-item-icon">
                                    <i className={page.isHome ? "pi pi-home" : "pi pi-file"} />
                                </div>
                                <div className="admin-page-item-info">
                                    <span className="admin-page-item-label admin-text-sm">{page.navLabel || page.title}</span>
                                    <small className="admin-page-item-slug admin-text-xs">/{page.slug}</small>
                                </div>
                            </div>
                            {page.isHome && <Tag value="Inicio" severity="success" className="admin-page-item-tag" />}
                            {page.textOnly && <Tag value="Texto" severity="warning" className="admin-page-item-tag" />}
                            <Ripple />
                        </div>
                    ))}
                </div>
            </div>
        )}
    </aside>
);

export default PageSidebar;
